export class HttpError extends Error {
    public status: number;
    public statusText: string;
    public url: string;

    constructor(status: number, statusText: string, url: string) {
        super(`Request failed with status ${status}${statusText ? ` ${statusText}` : ''}`);
        this.name = 'HttpError';
        this.status = status;
        this.statusText = statusText;
        this.url = url;
    }
}

export async function request<T = any>(url: string, init: RequestInit = {}): Promise<T | undefined> {
    const hasBody = init.body !== undefined;

    const response = await fetch(url, {
        ...init,
        headers: {
            'Accept': 'application/json',
            ...(hasBody ? { 'Content-Type': 'application/json' } : {}),
        },
    });

    if (!response.ok) {
        throw new HttpError(response.status, response.statusText, url);
    }

    if (response.status !== 200) {
        return undefined;
    }

    const text = await response.text();
    return text ? (JSON.parse(text) as T) : undefined;
}

export  function logHttpError(error: unknown): undefined {
    const err = error instanceof Error ? error : new Error(String(error));
    const errorMsg = `${err.name}: ${err.message}`;

    const errorStack = err instanceof HttpError
        ? JSON.stringify({
            name: err.name,
            message: err.message,
            status: err.status,
            statusText: err.statusText,
            url: err.url,
        })
        : err.stack;

    // eslint-disable-next-line no-console
    console.warn(
        `fetch() failed with "${errorMsg}". Full error:\n${errorStack}`
    );

    return undefined;
}
